module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "frame"
  }, [_c('div', {
    staticClass: "frame-wrapper"
  }, [_c('section', {
    staticClass: "frame-content"
  }, [_c('div', {
    staticClass: "frame-viewer"
  }, [_c('pdf', {
    ref: "pdf",
    attrs: {
      "spineAdjust": _vm.spineAdjust,
      "url": _vm.url,
      "zoom": _vm.zoom,
      "page": _vm.page,
      "unit": _vm.preferences.unit,
      "showOverview": _vm.preferences.showOverview,
      "showOverprint": _vm.preferences.showOverprint,
      "showInks": _vm.preferences.showInks,
      "showRulers": _vm.preferences.showRulers,
      "showBoxes": _vm.preferences.showBoxes,
      "selectedInks": _vm.preferences.selectedInks,
      "selectedBoxes": _vm.preferences.selectedBoxes,
      "changePage": _vm.changePage,
      "onFileLoaded": _vm.handleFileLoaded,
      "zoomEnd": _vm.zoomEnd
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f07eb89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Frame.vue
// module id = 419
// module chunks = 1